import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { V9EmilyMorningPlayingAfter } from "./V9";
import { empty } from "../characters/empty";
import { vanessa } from "../characters/Vanessa";
import { alex } from "../characters/Alex";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { alexImages } from "../helpers/alexInstaImages";
import { emily } from "../characters/Emily";
import { doImageShake, doLoopImages, doSmsSound, doTransition, doWaitImageByTime, isAgreedToChrisProposal, isFollowingVanessaLead } from "../helpers/helpers";

export const V9EmilyMorningPlaying = async (): Promise<any> => {
    // playing candy crush
    doTransition(images.v9.V9EmilyMorningPlaying_0.partials.V9EmilyMorningPlaying_0_p, { putParent: true });
    mc.think(`Vanessa should be arriving here shortly.`);
    doSmsSound();
    mc.think(`That must be her.`);

    await Phone.showMessagesUI({ name: alex.name }, async () => {
        Phone.setMessage({ character: alex.character, text: `heyyyyy`, options: { wait: false } });
        Phone.talk({ character: mc.character, text: `Alex...?` });
        Phone.talk({ character: mc.character, text: `I wonder what she wants.` });
        Phone.talk({ character: mc.character, text: ``, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Hey!` });
        Phone.setMessage({ character: alex.character, text: `I was wondering if I could get your help with something...` });
        Phone.setMessage({ character: mc.character, text: `Sure! What is it?` });
        Phone.setMessage({ character: alex.character, text: `I have this certain photo of mine...\nAnd I'm not sure if it's appropriate to post it on my Insta.` });
        Phone.setMessage({ character: alex.character, text: `Can you please be honest and tell me if it's something I should post?` });
        Phone.setMessage({ character: mc.character, text: `Yes, of course.` });
        await Phone.setMessage({ character: alex.character, text: `Yay! 😘` });
        Phone.setImage({ ...alexImages.Alex43, character: alex.character, options: { wait: false } });
        Phone.setMessage({ character: alex.character, text: `Like you can see... It's really revealing.` });
        Phone.talk({ character: mc.character, text: `Wow! Her nipples are almost visible in this one.`, options: { wait: true } });
        Phone.talk({ character: mc.character, text: ``, options: { wait: false } });
        await Phone.setQuestion({
            character: alex.character, question: new Question({ text: `So?`, options: { think: false }, key: `v9ToldAlexToPostHerPic` })
                .option({ title: `Post it`, key: true })
                .option({ title: `Don't post it`, key: false })
        });
        if (Question.globalAnswers.v9ToldAlexToPostHerPic) {
            Phone.setMessage({ character: mc.character, text: `You should post it.` });
        } else {
            Phone.setMessage({ character: mc.character, text: `Don't post it.` });
        }
        Phone.setMessage({ character: alex.character, text: `You really think so?` });

        await Phone.setQuestion({
            character: alex.character, question: new Question({ text: `Really?`, options: { think: false }, key: `v9AlexPhoneFlirtedWithHer` })
                .option({ title: `Flirtatious Response`, key: true })
                .option({ title: `Neutral Response`, key: false })
        });
        //flirting
        await empty.set((properties) => {
            properties.tempString = ``;
        });
        if (Question.globalAnswers.v9AlexPhoneFlirtedWithHer) {
            await mc.set((properties) => {
                properties.alexRelationship++;
            });
            if (Question.globalAnswers.v9ToldAlexToPostHerPic) {
                await empty.set((properties) => {
                    properties.tempString = `Of course! You shouldn't hide a hot body like that!`;
                });
                Phone.setMessage({ character: mc.character, text: empty.properties.tempString });
            } else {
                await empty.set((properties) => {
                    properties.tempString = `You have an extremely hot body, but you should give people some room for imagination.\nBut if you feel like sharing, feel free to send them over 😏`;
                });
                Phone.setMessage({ character: mc.character, text: empty.properties.tempString });
            }
        } else {
            // not flirting
            if (Question.globalAnswers.v9ToldAlexToPostHerPic) {
                await empty.set((properties) => {
                    properties.tempString = `Yes, you've posted much more revealing photos before.`;
                });
                Phone.setMessage({ character: mc.character, text: empty.properties.tempString });
            } else {
                await empty.set((properties) => {
                    properties.tempString = `Yes, I think it's too revealing to post on Insta.`;
                });
                Phone.setMessage({ character: mc.character, text: empty.properties.tempString });
            }
        }

        Phone.setMessage({ character: alex.character, text: `Alright!` });
        Phone.setMessage({ character: mc.character, text: `Really? That's all it takes to convince you?` });
        Phone.setMessage({ character: alex.character, text: `I asked for your opinion, it would have been rude not to listen! 😜` });
        ImageClass.setImage(images.v9.V9EmilyMorningPlaying_0, { duration: 0 });
        if (Question.globalAnswers.v9AlexPhoneFlirtedWithHer && Question.globalAnswers.v9ToldAlexToPostHerPic == false) {
            await Phone.setMessage({ character: alex.character, text: `Here is your reward 😘` });

        } else {
            await Phone.setMessage({ character: alex.character, text: `I think you deserve a reward for helping 😘` });

        }
        Phone.setImage({ ...images.v9.V9AlexPhone1, character: alex.character, options: { wait: false } });
        Phone.setImage({ ...images.v9.V9AlexPhone2, character: alex.character, options: { wait: false } });




        Phone.closeMessagesUI();
    });

    return jump(V9EmilyMorningPlaying_Emily, "V9EmilyMorningPlaying_Emily");
};

export const V9EmilyMorningPlaying_Emily = async (): Promise<any> => {
    mc.think(`Damn!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_1);
    emily.talk(`Watcha looking at?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_2);
    emily.talk(`Oh WOW!`);
    emily.talk(`Wait, isn't that our new neighbor???`);
    mc.talk(`What the fuck??? That's mine!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_3);
    emily.talk(`NOT ANYMORE!`);
    mc.talk(`Give it back!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_6);
    mc.talk(`You have one second to give it back to me!`);
    emily.talk(`Oh yeah?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_4);
    emily.talk(`PTHHHH!`);
    mc.talk(`Emily! Last chance!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_5);
    emily.talk(`PTHHHH!!!`);
    ImageClass.setImage(images.v9.Anim_V9EmilyMorningPlayingMatrix.poster);
    emily.talk(`Ah!!!`);
    ImageClass.setAnimation(images.v9.Anim_V9EmilyMorningPlayingMatrix, { wait: true, loop: 0, duration: 0 });

    doImageShake(images.v9.V9EmilyMorningPlaying_10);
    emily.talk(`What are you talking about? Let me see!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_9);
    mc.talk(`I will, just give me the phone first.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_11);
    emily.talk(`Just let me see the pictures!`);
    mc.talk(`I will, but give me the choice to show you!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_37);

    emily.talk(`Ewww! ${empty.properties.tempString}`);
    mc.talk(`Ok! That's it! I didn't want to do it!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_38);
    mc.talk(`Tickle tickle tickle!`);
    emily.talk(`HAHAHA! No!!!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_12);
    emily.talk(`Okay okay I'll give it to you!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_13);
    mc.talk(`So release it.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_14);
    emily.talk(`IN YOUR DREAMS!`);
    mc.talk(`Jeez...`);
    mc.talk(`Okay! Enough games!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_17);
    mc.think(`Where is it?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_15);
    emily.talk(`Haha!`);
    mc.talk(`The tickle train is coming...`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_17);
    emily.talk(`No!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_18);
    mc.talk(`Where is it?!`);
    doWaitImageByTime(images.v9.V9EmilyMorningPlaying_19);
    mc.think(`Mmm... That's not my phone...`);

    return jump(V9EmilyMorningPlaying_Emily_Vanessa, "V9EmilyMorningPlaying_Emily_Vanessa");
};
export const V9EmilyMorningPlaying_Emily_Vanessa = async (): Promise<any> => {
    doImageShake(images.v9.V9EmilyMorningPlaying_20);
    vanessa.talk(`What are you doing?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_21);
    mc.talk(`No--`);
    emily.talk(`--thing!`);
    doWaitImageByTime(images.v9.V9EmilyMorningPlaying_22);
    vanessa.talk(`Are you sure?`);
    mc.talk(`Yes!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_23);
    mc.talk(`Yes, I was just looking for my phone.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_24);
    vanessa.talk(`Rrrrright.`);
    doWaitImageByTime(images.v9.V9EmilyMorningPlaying_25);
    vanessa.talk(`AAAAnyway...`);
    vanessa.talk(`Are you ready to go?`);
    mc.talk(`Sure, let's go.`);
    doWaitImageByTime(images.v9.V9EmilyMorningPlaying_26);
    vanessa.talk(`Nice seeing you again... Goddess...`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_27.partials.V9EmilyMorningPlaying_28, { putParent: true });
    emily.talk(`Oh, hey!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_26);
    vanessa.talk(`Can I ask you something?`);
    vanessa.talk(`Pretty please!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_27.partials.V9EmilyMorningPlaying_28, { putParent: true });
    emily.talk(`Of course! How can I help you?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_26);
    vanessa.talk(`I gotta squeeze that ass.`);
    vanessa.talk(`Can I do it?`);
    vanessa.talk(`Just a quick grab!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_27);
    emily.talk(`Ah...`);
    emily.talk(`I guess... I don't see how it could do any harm.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_26);
    // TODO: whispering font
    vanessa.talk(`I love you!`, { method: "Whispering" });
    vanessa.talk(`I mean, thanks!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_29);
    vanessa.talk(`A dream come true!`);

    doLoopImages([images.v9.V9EmilyMorningPlaying_31, images.v9.V9EmilyMorningPlaying_30], 0.6, undefined, { wait: true });
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_32);
    vanessa.talk(`Oh my god! It's so soft!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_33);
    emily.talk(`Ah... I need to get going.`);
    doLoopImages([images.v9.V9EmilyMorningPlaying_31, images.v9.V9EmilyMorningPlaying_30], 0.1, 0, { wait: true });
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_34);
    emily.talk(`I'll talk to you later!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_35);
    vanessa.talk(`Uff...`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_36);
    vanessa.talk(`So what were you really doing?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_40);
    mc.talk(`Nothing... She took my phone and I was trying to get it back.`);
    vanessa.talk(`Interesting.`);
    mc.talk(`What?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_36);
    vanessa.talk(`Nothing.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_39);
    mc.talk(`Where are we even going?`);
    if (isFollowingVanessaLead()) {
        ImageClass.setImage(images.v9.V9EmilyMorningPlaying_41);
        vanessa.talk(`I don't know.`);
        ImageClass.setImage(images.v9.V9EmilyMorningPlaying_39);
        mc.talk(`I thought you had a plan.`);
        ImageClass.setImage(images.v9.V9EmilyMorningPlaying_41);
        vanessa.talk(`I have a plan, not a location.`);
    } else {
        ImageClass.setImage(images.v9.V9EmilyMorningPlaying_41);
        vanessa.talk(`That's up to you!`);
    }
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_39);
    mc.talk(`Mmm...`);
    if (isAgreedToChrisProposal()) {
        mc.talk(`We can go to Chris' bar.`);
    } else {
        mc.talk(`Chris asked me to help him with something at his bar, I guess we can go there.`);

    }
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_41);
    vanessa.talk(`Fine by me!`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_39);

    mc.talk(`Oh fuck, that's not going to work.`);
    mc.talk(`Emily just said she's leaving; she'll probably take her car.`);

    mc.talk(`I guess our plan is ruined.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_41);
    vanessa.talk(`So?`);
    vanessa.talk(`We'll just take the bus.`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_39);
    mc.talk(`BUS? You?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_41);
    vanessa.talk(`Why not?`);

    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_39);
    mc.talk(`Would your highness agree to ride the bus with us common peasants?`);
    ImageClass.setImage(images.v9.V9EmilyMorningPlaying_42);
    vanessa.talk(`Oh, but of course! The chance to descend among the quaint peasants and partake in their rudimentary bus adventures? How could I resist such a primitive delight?`);
    mc.talk(`...`);


    return jump(V9EmilyMorningPlayingAfter, "V9EmilyMorningPlayingAfter");
};
